import * as React from "react";

import BODebounceInput from "app/components/BOComponents/BODebounceInput";

import AllCardLoadsContainer from "app/components/AppComponents/CardLoads/AllCardLoadsContainer";

type State = {
  search: string;
};

export default class List extends React.Component<any, State> {
  state = {
    search: null
  };

  componentDidMount() {
    this.props.setHeader({
      title: "Ops > Card Loads",
      description: "SnapScan card loads"
    });
  }

  render() {
    return (
      <section className="padded">
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            flexDirection: "column"
          }}
        >
          <BODebounceInput
            minLength={2}
            debounceTimeout={300}
            placeholder="Search User"
            onChange={newValue => {
              this.setState({ search: newValue });
            }}
          />
        </div>
        <AllCardLoadsContainer
          name={"ops.cardloads.list"}
          search={this.state.search}
        />
      </section>
    );
  }
}
